import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import Box from '../box/box.jsx';
import styles from './blocks.css';

const BlocksComponent = props => {
    const {
        containerRef,
        dragOver,
        floatingWorkspacePosition,
        ...componentProps
    } = props;
    void floatingWorkspacePosition;
    return (
        <Box
            className={classNames(styles.blocks, {
                [styles.dragOver]: dragOver
            })}
            {...componentProps}
            componentRef={containerRef}
        />
    );
};
BlocksComponent.propTypes = {
    containerRef: PropTypes.func,
    dragOver: PropTypes.bool,
    floatingWorkspacePosition: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number
    })
};
export default BlocksComponent;
